/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const carouselDotsStyle = {
  button: (theme: Theme) => ({
    display: "flex",
    minWidth: "0",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: 0,
    boxSizing: "content-box",
    borderStyle: "solid",
    borderWidth: "0.125rem",
    borderRadius: "100%",
    borderColor: theme.palette.mode === "light" ? "grey.600" : "grey.400",
    width: "0.5rem",
    height: "0.5rem",
    cursor: "pointer",
    "&:focus-visible::after": {
      content: "''",
      position: "absolute",
      width: "calc(100% + 0.5rem)",
      height: "calc(100% + 0.5rem)",
      borderWidth: "0.125rem",
      borderStyle: "solid",
      borderColor: theme.palette.mode === "light" ? "grey.900" : "grey.200",
      borderRadius: "100%",
    },
  }),
  activeButton: (theme: Theme) => ({
    backgroundColor: theme.palette.mode === "light" ? "common.black" : "common.white",
  }),
  inactiveButton: {
    backgroundColor: "transparent",
  },
};
